import React, { useEffect, useState } from "react";
import NeoInsurance from "../../assets/svgs/NRMIB 1.svg";
import { OverlayLoader, LargeButton } from "../../components";
import { Ptag } from "../../components/fonts";
import {
  Body,
  Header,
  LoginWrapper,
  ButtonDiv,
  Divider,
  Divv,
  Separator,
} from "./styles";
import "./styleing.css";
import { theme } from "../../theme";
import { Snackbar } from "@material-ui/core";
import { useHistory } from "react-router-dom";
import { Alert } from "@material-ui/lab";
import { makeStyles } from "@material-ui/styles";

const EmployeeLogin = () => {
  const history = useHistory();

  useEffect(() => {
    localStorage.clear();
    sessionStorage.clear();
    const queryParameters = new URLSearchParams(window.location.search);
    const type = queryParameters.get("platform");
    if (type) localStorage.setItem("platform");
  }, []);

  const [errorSnackbar, setErrorSnackbar] = useState({
    display: false,
    message: "Some error has occured!",
  });
  const [loading, setLoading] = useState(false);

  const useStyles = makeStyles({
    cookieAlert: {
      "& .MuiAlert-message": {
        fontSize: "14px",
      },
    },
  });

  const handleSubmit1 = (value) => {
    localStorage.setItem("CONSOLE_NEO", true);
    console.log(value, 12);
    history.push("/login/phone");
  };
  const handleSubmit2 = (value) => {
    localStorage.setItem("CONSOLE_VITAL", true);
    console.log(value, 23);
    history.push("/login/member-id");
  };

  const classes = useStyles();

  return (
    <>
      {loading ? (
        <OverlayLoader />
      ) : (
        <LoginWrapper>
          <Snackbar
            open={errorSnackbar.display}
            autoHideDuration={4000}
            onClose={() =>
              setErrorSnackbar((prev) => ({ ...prev, display: false }))
            }
          >
            <Alert severity="error" className={classes.cookieAlert}>
              {errorSnackbar.message}
            </Alert>
          </Snackbar>
          <Header>
            <img style={{ width: "300px" }} src={NeoInsurance} />
          </Header>
          <Body>
            <Ptag
              color="#fff"
              fontSize="28px"
              textAlign="center"
              fontWeight="600"
              marginTop="4rem"
            >
              Welcome!
            </Ptag>
            <ButtonDiv>
              <LargeButton
                onClick={handleSubmit1}
                bgColor={theme.primaryColor}
                borderColor="#F8F5FE"
                textColor="#F8F5FE"
                style={{
                  letterSpacing: "0.5px",
                }}
                label="Login With Mobile Number"
              />
              <Divv>
                <Divider>or</Divider>
              </Divv>
              <LargeButton
                onClick={handleSubmit2}
                bgColor={theme.primaryColor}
                borderColor="#F8F5FE"
                textColor="#F8F5FE"
                style={{
                  letterSpacing: "0.5px",
                }}
                label="Login With Employee Id"
              />
            </ButtonDiv>
          </Body>
        </LoginWrapper>
      )}
    </>
  );
};

export default EmployeeLogin;
